import { Slot } from "@radix-ui/react-slot";
import { type VariantProps, cva } from "class-variance-authority";
import {
	ElementType,
	type HTMLAttributes,
	type PropsWithChildren,
	forwardRef,
} from "react";
import { cn } from "../lib/utils";

const stackVariants = cva("flex", {
	variants: {
		direction: {
			vertical: "flex-col",
			horizontal: "",
		},
	},
	defaultVariants: {
		direction: "horizontal",
	},
});

export interface StackProps
	extends HTMLAttributes<HTMLDivElement>,
		PropsWithChildren<VariantProps<typeof stackVariants>> {
	ele?: ElementType;
	asChild?: boolean;
}

const Stack = forwardRef<HTMLDivElement, StackProps>(
	(
		{ children, className, direction, asChild, ele, ...props },
		ref,
	): React.ReactElement => {
		const Comp = asChild ? Slot : (ele ?? "div");
		return (
			<Comp
				className={cn(stackVariants({ direction }), className)}
				ref={ref}
				{...props}
			>
				{children}
			</Comp>
		);
	},
);

Stack.displayName = "Stack";

// NOTE: Not sure about this tbh
export const VStack = forwardRef<HTMLDivElement, Omit<StackProps, "direction">>(
	(props, ref): React.ReactElement => {
		return <Stack direction="vertical" ref={ref} {...props} />;
	},
);

VStack.displayName = "VStack";

export const HStack = Stack;
